import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=ef6c4bb0&scoped=true&"
import script from "./Spacer.vue?vue&type=script&lang=js&"
export * from "./Spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6c4bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef6c4bb0')) {
      api.createRecord('ef6c4bb0', component.options)
    } else {
      api.reload('ef6c4bb0', component.options)
    }
    module.hot.accept("./Spacer.vue?vue&type=template&id=ef6c4bb0&scoped=true&", function () {
      api.rerender('ef6c4bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v2/schema/Spacer.vue"
export default component.exports